<template>
    <div
        class="bg-light mx-auto my-auto rounded shadow-default"
        :class="$mq.smPlus ? 'p-32' : 'p-20'"
        style="max-width: 640px"
    >
        <div class="w-100 mb-10 text-right">
            <button-link
                icon="close"
                :aria-label="ucfirst($t('common.close'))"
                @click="close"
            />
        </div>

        <div v-html="text" />
    </div>
</template>

<script>
import { ucfirst } from "~/lib/utils"
import ButtonLink from "~/components/buttons/ButtonLink"

export default {
    inject: ["popModal"],

    props: {
        text: String,
    },

    methods: {
        close() {
            this.popModal()
        },

        ucfirst,
    },

    components: {
        ButtonLink,
    },
}
</script>
